<template>
  <div class="row">
    <!-- Big Chart -->
    <div class="col-12">
      <card type="chart">
        <template slot="header">
          <div class="row">
            <div class="col-sm-6" :class="isRTL ? 'text-right' : 'text-left'">
              <h5 class="card-category">Dashboard operacional</h5>
              <h2 class="card-title">
                {{ $t("checklist.dashboard.formFilled") }}
              </h2>
            </div>
            <div class="col-sm-6 d-flex d-sm-block">
              <div
                class="btn-group btn-group-toggle"
                :class="isRTL ? 'float-left' : 'float-right'"
                data-toggle="buttons"
              >
                <label
                  v-for="(option, index) in bigLineChartCategories"
                  :key="option.name"
                  class="btn btn-sm btn-white btn-simple"
                  :class="{ active: bigLineChart.activeIndex === index }"
                  :id="index"
                >
                  <input
                    type="radio"
                    @click="initBigChart(index)"
                    name="options"
                    autocomplete="off"
                    :checked="bigLineChart.activeIndex === index"
                  />
                  <span class="d-none d-sm-block">{{ option.name }}</span>
                  <span class="d-block d-sm-none">
                    {{ option.name.substring(0, 1) }}
                    <!-- <i :class="option.icon"></i> -->
                  </span>
                </label>
              </div>
            </div>
          </div>
        </template>
        <div class="chart-area">
          <line-chart
            style="height: 100%"
            ref="bigChart"
            :chart-data="bigLineChart.chartData"
            :gradient-colors="bigLineChart.gradientColors"
            :gradient-stops="bigLineChart.gradientStops"
            :extra-options="bigLineChart.extraOptions"
          ></line-chart>
        </div>
      </card>
    </div>
    <!-- Stats Cards -->
    <!-- <div class="row justify-content-center">
      <div
        v-for="(card, index) in statsCards"
        :key="card.title"
        :class="[
          'mb-3',
          index < 3 ? 'col-lg-2' : 'col-lg-3',
          'col-md-4',
          'col-sm-6',
        ]"
      >
        <stats-card
          :title="card.title"
          :sub-title="card.subTitle"
          :type="card.type"
          :icon="card.icon"
        >
          <div slot="footer" v-html="card.footer"></div>
        </stats-card>
      </div>
    </div> -->
    <div class="col-lg-3 col-md-4" v-for="card in statsCards" :key="card.title">
      <stats-card
        :title="card.title"
        :sub-title="card.subTitle"
        :type="card.type"
        :icon="card.icon"
      >
        <div slot="footer" v-html="card.footer"></div>
      </stats-card>
    </div>

    <!-- Small charts -->
    <div class="col-lg-4" :class="{ 'text-right': isRTL }">
      <card type="chart">
        <template slot="header">
          <h5 class="card-category">
            {{ $t("checklist.dashboard.formFilledByType") }}
          </h5>
          <h3 class="card-title">
            <i class="tim-icons icon-paper text-danger"></i>
            <!-- {{$t("dashboard.ocorrencias")}} -->
          </h3>
        </template>
        <div class="chart-area">
          <pie-chart
            :chart-data="pieChart2.chartData"
            :extra-options="pieChart2.extraOptions"
            :height="200"
          ></pie-chart>
        </div>
      </card>
    </div>
    <div class="col-lg-4" :class="{ 'text-right': isRTL }">
      <card type="chart">
        <template slot="header">
          <h5 class="card-category">
            {{ $t("checklist.dashboard.rankFillers") }}
          </h5>
          <h3 class="card-title">
            <i class="tim-icons icon-trophy text-info"></i>
          </h3>
        </template>
        <div class="chart-area">
          <bar-chart
            style="height: 100%"
            :chart-data="blueBarChart.chartData"
            :gradient-stops="blueBarChart.gradientStops"
            :extra-options="blueBarChart.extraOptions"
          ></bar-chart>
        </div>
      </card>
    </div>
    <div class="col-lg-4" :class="{ 'text-right': isRTL }">
      <card type="chart">
        <template slot="header">
          <h5 class="card-category">
            {{ $t("checklist.dashboard.pendenciesApproved") }}
          </h5>
          <h3 class="card-title">
            <i class="tim-icons icon-check-2 text-danger"></i>
          </h3>
        </template>
        <div class="chart-area">
          <line-chart
            style="height: 100%"
            :chart-data="greenLineChart.chartData"
            :gradient-stops="greenLineChart.gradientStops"
            :extra-options="greenLineChart.extraOptions"
          ></line-chart>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
function colorize(opaque, hover, ctx) {
  var v = ctx.dataset.data[ctx.dataIndex];
  var c =
    v < -50 ? "#D60000" : v < 0 ? "#F46300" : v < 50 ? "#0358B6" : "#44DE28";

  var opacity = hover ? 1 - Math.abs(v / 150) - 0.2 : 1 - Math.abs(v / 150);

  return opaque ? c : utils.transparentize(c, opacity);
}

function hoverColorize(ctx) {
  return colorize(false, true, ctx);
}

import LineChart from "@/components/Charts/LineChart";
import BarChart from "@/components/Charts/BarChart";
import PieChart from "@/components/Charts/PieChart";
import * as chartConfigs from "@/components/Charts/config";
import StatsCard from "src/components/Cards/StatsCard";
import config from "@/config";

let bigChartData = [
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];
let bigChartLabels = [
  ["", "", "", "", "", "", "", "", "", "", "", ""],
  ["", "", "", "", "", "", "", "", "", "", "", ""],
  ["", "", "", "", "", "", "", "", "", "", "", ""],
];
let bigChartDatasetOptions = {
  fill: true,
  borderColor: config.colors.primary,
  borderWidth: 2,
  borderDash: [],
  borderDashOffset: 0.0,
  pointBackgroundColor: config.colors.primary,
  pointBorderColor: "rgba(255,255,255,0)",
  pointHoverBackgroundColor: config.colors.primary,
  pointBorderWidth: 20,
  pointHoverRadius: 4,
  pointHoverBorderWidth: 15,
  pointRadius: 4,
};

export default {
  components: {
    LineChart,
    BarChart,
    PieChart,
    StatsCard,
  },
  data() {
    return {
      statsCards: [
        {
          title: "0",
          subTitle: this.$t("checklist.dashboard.opened"),
          type: "danger",
          icon: "tim-icons icon-alert-circle-exc",
          footer:
            '<i class="tim-icons icon-alert-circle-exc"></i> ' +
            this.$t("checklist.dashboard.pendenciesOpened"),
        },
        {
          title: "0",
          subTitle: this.$t("checklist.dashboard.formWithPendencies"),
          type: "primary",
          icon: "tim-icons icon-calendar-60",
          footer:
            '<i class="tim-icons icon-calendar-60"></i></i> ' +
            this.$t("checklist.dashboard.lastMonth"),
        },
        // {
        //   title: "0",
        //   subTitle: this.$t("checklist.dashboard.formFree"),
        //   type: "info",
        //   icon: "tim-icons icon-notes",
        //   footer:
        //     '<i class="tim-icons icon-trophy"></i> ' +
        //     this.$t("checklist.dashboard.lastMonth"),
        // },
        {
          title: "0%",
          subTitle: this.$t("checklist.dashboard.eficiency"),
          type: "success",
          icon: "tim-icons icon-satisfied",
          footer:
            '<i class="tim-icons icon-watch-time"></i> ' +
            this.$t("checklist.dashboard.lastMonth"),
        },
        {
          title: "0", //Total preenchido
          subTitle: "Total preenchidos",
          type: "primary",
          icon: "tim-icons icon-notes",
          footer:
            '<i class="tim-icons icon-calendar-60"></i></i> ' + "Mês atual",
        },
      ],
      bigLineChart: {
        activeIndex: 0,
        chartData: {
          datasets: [
            {
              ...bigChartDatasetOptions,
              data: bigChartData[0],
            },
          ],
          labels: bigChartLabels,
        },
        extraOptions: chartConfigs.greenChartOptions,
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.4, 0],
        categories: [],
      },
      purpleLineChart: {
        extraOptions: chartConfigs.purpleChartOptions,
        chartData: {
          labels: ["AGO", "SET", "OUT", "NOV", "DEZ"],
          datasets: [
            {
              label: "Data",
              fill: true,
              borderColor: config.colors.primary,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.primary,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: config.colors.primary,
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [1, 1, 0, 3, 4],
            },
          ],
        },
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.2, 0],
      },
      greenLineChart: {
        extraOptions: chartConfigs.greenChartOptions,
        chartData: {
          labels: ["", "", "", "", ""],
          datasets: [
            {
              label: this.$t("checklist.dashboard.approved"),
              fill: true,
              borderColor: config.colors.danger,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.danger,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: config.colors.danger,
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [0, 0, 0, 0, 0],
            },
          ],
        },
        gradientColors: [
          "rgba(66,134,121,0.15)",
          "rgba(66,134,121,0.0)",
          "rgba(66,134,121,0)",
        ],
        gradientStops: [1, 0.4, 0],
      },
      blueBarChart: {
        extraOptions: chartConfigs.barChartOptions,
        chartData: {
          labels: ["", "", "", "", "", ""],
          datasets: [
            {
              label: this.$t("checklist.dashboard.form"),
              fill: true,
              borderColor: config.colors.info,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [0, 0, 0, 0, 0, 0],
            },
          ],
        },
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.4, 0],
      },
      pieChart2: {
        chartData: {
          labels: ["", ""],
          datasets: [
            {
              label: this.$t("checklist.dashboard.formFilledByType"),
              pointRadius: 0,
              pointHoverRadius: 0,
              // backgroundColor: ["#ff8779", "#2a84e9", "#e2e2e2"],
              borderWidth: 0,
              data: [1, 1],
            },
          ],
        },
        extraOptions: chartConfigs.pieChartOptions,
      },
    };
  },
  computed: {
    enableRTL() {
      return this.$route.query.enableRTL;
    },
    isRTL() {
      return this.$rtl.isRTL;
    },
    bigLineChartCategories() {
      return [
        {
          name: "Meses",
          icon: "tim-icons icon-single-02",
        },
        {
          name: "Semanas",
          icon: "tim-icons icon-gift-2",
        },
        {
          name: "Dias",
          icon: "tim-icons icon-tap-02",
        },
      ];
    },
  },
  methods: {
    initBigChart(index) {
      let chartData = {
        datasets: [
          {
            ...bigChartDatasetOptions,
            data: bigChartData[index],
          },
        ],
        labels: bigChartLabels[index],
      };
      this.$refs.bigChart.updateGradients(chartData);
      this.bigLineChart.chartData = chartData;
      this.bigLineChart.activeIndex = index;
    },
    loadData() {
      this.$apiChecklist
        .get("/dashboard/default")
        .then((response) => {
          let dashboardData = response.data.data;
          console.log(dashboardData);

          this.statsCards[0].title = dashboardData.gauge1.value;
          this.statsCards[1].title = dashboardData.gauge2.value;
          this.statsCards[2].title = dashboardData.gauge4.value;
          this.statsCards[3].title = dashboardData.gauge5.value;

          // Mensal
          bigChartData[0] = [];
          bigChartLabels[0] = [];
          dashboardData.bigChart1.forEach((bc) => {
            bigChartData[0].push(bc.value);
            bigChartLabels[0].push(bc.label);
          });

          // Semanal
          bigChartData[1] = [];
          bigChartLabels[1] = [];
          dashboardData.bigChart2.forEach((bc) => {
            bigChartData[1].push(bc.value);
            bigChartLabels[1].push(bc.label);
          });

          // Bigchart diário
          bigChartData[2] = [];
          bigChartLabels[2] = [];
          dashboardData.bigChart3.forEach((bc) => {
            bigChartData[2].push(bc.value);
            bigChartLabels[2].push(bc.label);
          });

          this.initBigChart(0);

          // Gráfico de rosca - formulários por type
          let formsPerTypeData = [];
          let formsPerTypeLabels = [];
          dashboardData.smallChart1.forEach((c) => {
            formsPerTypeData.push(parseInt(c.value));
            formsPerTypeLabels.push(c.label);
          });

          let dynamicColors = function () {
            var r = Math.floor(Math.random() * 255);
            var g = Math.floor(Math.random() * 255);
            var b = Math.floor(Math.random() * 255);
            return "rgb(" + r + "," + g + "," + b + ")";
          };

          let formsPerTypeColors = ["#ff8779", "#2a84e9", "#e2e2e2"];
          if (formsPerTypeData.length > formsPerTypeColors.length) {
            for (
              let i = formsPerTypeColors.length - 1;
              i < formsPerTypeData.length;
              i++
            ) {
              formsPerTypeColors.push(dynamicColors());
            }
          }

          this.pieChart2 = {
            chartData: {
              labels: formsPerTypeLabels,
              datasets: [
                {
                  label: this.$t("checklist.dashboard.formFilledByType"),
                  pointRadius: 0,
                  pointHoverRadius: 0,
                  backgroundColor: formsPerTypeColors,
                  borderWidth: 0,
                  data: formsPerTypeData,
                },
              ],
            },
            extraOptions: chartConfigs.pieChartOptions,
          };

          // Gráfico em barras - ranking de preenchedores
          let fillersRankData = [];
          let fillersRankLabels = [];
          dashboardData.smallChart2.forEach((c) => {
            fillersRankData.push(parseInt(c.value));
            fillersRankLabels.push(c.label);
          });

          this.blueBarChart = {
            extraOptions: chartConfigs.barChartOptions,
            chartData: {
              labels: fillersRankLabels,
              datasets: [
                {
                  label: this.$t("checklist.dashboard.form"),
                  fill: true,
                  borderColor: config.colors.info,
                  borderWidth: 2,
                  borderDash: [],
                  borderDashOffset: 0.0,
                  data: fillersRankData,
                },
              ],
            },
            gradientColors: config.colors.primaryGradient,
            gradientStops: [1, 0.4, 0],
          };

          // Gráfico em linhas - preenchimentos ultimos 7 dias
          let fillsLastDaysData = [];
          let fillsLastDaysLabels = [];
          dashboardData.smallChart3.forEach((c) => {
            fillsLastDaysData.push(parseInt(c.value));
            fillsLastDaysLabels.push(c.label);
          });

          this.greenLineChart = {
            extraOptions: chartConfigs.greenChartOptions,
            chartData: {
              labels: fillsLastDaysLabels,
              datasets: [
                {
                  label: this.$t("checklist.dashboard.approved"),
                  fill: true,
                  borderColor: config.colors.danger,
                  borderWidth: 2,
                  borderDash: [],
                  borderDashOffset: 0.0,
                  pointBackgroundColor: config.colors.danger,
                  pointBorderColor: "rgba(255,255,255,0)",
                  pointHoverBackgroundColor: config.colors.danger,
                  pointBorderWidth: 20,
                  pointHoverRadius: 4,
                  pointHoverBorderWidth: 15,
                  pointRadius: 4,
                  data: fillsLastDaysData,
                },
              ],
            },
            gradientColors: [
              "rgba(66,134,121,0.15)",
              "rgba(66,134,121,0.0)",
              "rgba(66,134,121,0)",
            ],
            gradientStops: [1, 0.4, 0],
          };
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            console.log(error);
            console.log(error.response.data.errors);
          }
          //   if (error.response.status == 400) {
          //     this.modelstate = error.response.data.errors;
          //   }
        });
    },
  },
  mounted() {
    this.i18n = this.$i18n;
    if (this.enableRTL) {
      this.i18n.locale = "ar";
      this.$rtl.enableRTL();
    }
    this.initBigChart(0);
    this.loadData();
  },
  beforeDestroy() {
    if (this.$rtl.isRTL) {
      this.i18n.locale = "en";
      this.$rtl.disableRTL();
    }
  },
};
</script>
<style></style>
